<script setup lang="ts">
import Button from "../../base-components/Button";
import { ref } from "vue";

import { userUserStore } from "../../stores/user";
import OpcionesGeneralesEditar from "./components/OpcionesGeneralesEditar.vue";
import OpcionesGeneralesHandy from "./components/OpcionesGeneralesHandy.vue";
import OpcionesGeneralesFiserv from "./components/OpcionesGeneralesFiserv.vue";
import OpcionesGeneralesGetnet from "./components/OpcionesGeneralesGetnet.vue";
import OpcionesGeneralesOCA from "./components/OpcionesGeneralesOCA.vue";
import OpcionesGeneralesScanntech from "./components/OpcionesGeneralesScanntech.vue";
import OpcionesGeneralesTicketera from "./components/OpcionesGeneralesTicketera.vue";

const userStore = userUserStore();
const showFormAgregar = ref(false);
const showFormAgregarTicketera = ref(false);
const showFormHandy = ref(false);
const showFormOCA = ref(false);
const showFormFiserv = ref(false);
const showFormGetnet = ref(false);
const showFormScanntech = ref(false);
</script>

<template>
  <div v-if="!showFormAgregar" class="mt-12">
    <Button
      class="w-full"
      variant="primary"
      size="lg"
      @click="
        () => {
          showFormAgregar = true;
        }
      "
    >
      <div class="p-3 flex items-center">
        <i class="fas fa-arrow-left mr-2"></i>
        <h2 class="text-lg">Opciones Generales</h2>
      </div>
    </Button>
  </div>
  <div v-else class="mt-5">
    <OpcionesGeneralesEditar
      @cerrar="
        () => {
          showFormAgregar = false;
        }
      "
    />
  </div>
  <div v-if="!showFormAgregarTicketera" class="mt-12">
    <Button
      class="w-full"
      variant="primary"
      size="lg"
      @click="
        () => {
          showFormAgregarTicketera = true;
        }
      "
    >
      <div class="p-3 flex items-center">
        <i class="fas fa-arrow-left mr-2"></i>
        <h2 class="text-lg">Opciones Ticketeras</h2>
      </div>
    </Button>
  </div>
  <div v-else class="mt-5">
    <OpcionesGeneralesTicketera
      @cerrar="
        () => {
          showFormAgregarTicketera = false;
        }
      "
    />
  </div>
  <template v-if="userStore.opcionesGenerales.integracionPOSHandy.habilitado">
    <div v-if="!showFormHandy" class="mt-12">
      <Button
        class="w-full"
        variant="primary"
        size="lg"
        @click="
          () => {
            showFormHandy = true;
          }
        "
      >
        <div class="p-3 flex items-center">
          <i class="fas fa-arrow-left mr-2"></i>
          <h2 class="text-lg">Opciones Handy</h2>
        </div>
      </Button>
    </div>

    <div v-else class="mt-5">
      <OpcionesGeneralesHandy
        @cerrar="
          () => {
            showFormHandy = false;
          }
        "
      />
    </div>
  </template>

  <template v-if="userStore.opcionesGenerales.integracionPOSOCA.habilitado">
    <div v-if="!showFormOCA" class="mt-12">
      <Button
        class="w-full"
        variant="primary"
        size="lg"
        @click="
          () => {
            showFormOCA = true;
          }
        "
      >
        <div class="p-3 flex items-center">
          <i class="fas fa-arrow-left mr-2"></i>
          <h2 class="text-lg">Opciones OCA</h2>
        </div>
      </Button>
    </div>

    <div v-else class="mt-5">
      <OpcionesGeneralesOCA
        @cerrar="
          () => {
            showFormOCA = false;
          }
        "
      />
    </div>
  </template>

  <template v-if="userStore.opcionesGenerales.integracionPOSFiserv.habilitado">
    <div v-if="!showFormFiserv" class="mt-12">
      <Button
        class="w-full"
        variant="primary"
        size="lg"
        @click="
          () => {
            showFormFiserv = true;
          }
        "
      >
        <div class="p-3 flex items-center">
          <i class="fas fa-arrow-left mr-2"></i>
          <h2 class="text-lg">Opciones Fiserv</h2>
        </div>
      </Button>
    </div>

    <div v-else class="mt-5">
      <OpcionesGeneralesFiserv
        @cerrar="
          () => {
            showFormFiserv = false;
          }
        "
      />
    </div>
  </template>

  <template v-if="userStore.opcionesGenerales.integracionPOSGetnet.habilitado">
    <div v-if="!showFormGetnet" class="mt-12">
      <Button
        class="w-full"
        variant="primary"
        size="lg"
        @click="
          () => {
            showFormGetnet = true;
          }
        "
      >
        <div class="p-3 flex items-center">
          <i class="fas fa-arrow-left mr-2"></i>
          <h2 class="text-lg">Opciones Getnet</h2>
        </div>
      </Button>
    </div>

    <div v-else class="mt-5">
      <OpcionesGeneralesGetnet
        @cerrar="
          () => {
            showFormGetnet = false;
          }
        "
      />
    </div>
  </template>

  <template
    v-if="userStore.opcionesGenerales.integracionPOSScanntech.habilitado"
  >
    <div v-if="!showFormScanntech" class="mt-12">
      <Button
        class="w-full"
        variant="primary"
        size="lg"
        @click="
          () => {
            showFormScanntech = true;
          }
        "
      >
        <div class="p-3 flex items-center">
          <i class="fas fa-arrow-left mr-2"></i>
          <h2 class="text-lg">Opciones Scanntech</h2>
        </div>
      </Button>
    </div>

    <div v-else class="mt-5">
      <OpcionesGeneralesScanntech
        @cerrar="
          () => {
            showFormScanntech = false;
          }
        "
      />
    </div>
  </template>
</template>
